<template>
  <div class="min-h-screen flex flex-col font-sans">
    <div class="grid grid-cols-5 relative overflow-hidden">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        class="absolute z-20 transform rotate-90 text-blue-900 hidden md:block"
      >
        <path
          fill="currentColor"
          fill-opacity="1"
          d="M0,224L80,229.3C160,235,320,245,480,240C640,235,800,213,960,218.7C1120,224,1280,256,1360,272L1440,288L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        ></path>
      </svg>

      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        class="absolute z-20 transform rotate-90 text-blue-900"
      >
        <path
          fill="currentColor"
          fill-opacity="1"
          d="M0,256L48,229.3C96,203,192,149,288,154.7C384,160,480,224,576,218.7C672,213,768,139,864,128C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg> -->
      <div
        class="bg-blue-900 col-span-5 md:col-span-2 z-10 md:min-h-screen flex flex-col items-center justify-center pb-8 md:pb-0"
      >
        <!-- <svg
          class="absolute top-8 left-5 transform translate-x-1/2 text-blue-700 lg:mt-28 lg:mb-0 xl:transform-none xl:translate-x-0"
          width="200"
          height="190"
          viewBox="0 0 200 190"
          fill="none"
        >
          <defs>
            <pattern
              id="eab71dd9-9d7a-47bd-8044-256344ee00d0"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect x="0" y="0" width="4" height="4" fill="currentColor" />
            </pattern>
          </defs>
          <rect
            width="364"
            height="384"
            fill="url(#eab71dd9-9d7a-47bd-8044-256344ee00d0)"
          />
        </svg> -->
        <div class="mx-auto pt-8 px-4 sm:px-6 lg:px-8">
          <h2 class="font-sriracha text-center my-4">
            <span
              class="font-semibold md:text-6xl text-4xl leading-5 text-blue-400 inline-block tracking-normal"
              >mi</span
            >
            <span
              class="font-extrabold text-4xl md:text-6xl text-gray-100 leading-5 inline-block tracking-normal"
              >Curriculum</span
            >
          </h2>
          <h1
            class="mt-2 mb-8 md:text-4xl text-2xl text-center leading-10 font-extrabold tracking-tight text-indigo-200 sm:text-4xl sm:leading-none"
          >
            Redacta tu curriculum
            <span
              class="bg-gradient-to-tl from-red-400 to-indigo-100 text-transparent bg-clip-text"
              >moderno</span
            >
            y atractivo en minutos
          </h1>

          <!-- <form class="mt-8 sm:flex" aria-labelledby="newsletter-headline">
            <input
              aria-label="Email address"
              type="email"
              required
              class="appearance-none w-full px-5 py-3 border border-gray-300 text-base leading-6 rounded-md text-gray-100 bg-white placeholder-gray-500 focus:outline-none focus:shadow-outline focus:border-blue-300 transition duration-150 ease-in-out sm:max-w-xs"
              placeholder="Enter your email"
            />
            <div
              class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0"
            >
              <button
                class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
              >
                Notify me
              </button>
            </div>
          </form> -->
        </div>
        <!-- <p
          class="text-gray-400 font-semibold text-xl px-4 text-center hidden md:block"
        >
          Elige entre varias plantillas y colores.
        </p> -->
        <p
          class="text-gray-100 font-semibold text-xl px-4 sm:px-6 lg:px-8 text-center mb-4"
        >
          miCurriculum es totalmente gratis, queremos ayudarte a que encuentres
          tu próximo trabajo
        </p>
        <div class="flex">
          <div
            class="mt-5 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0 w-64 text-center"
          >
            <button
              @click="navigate"
              class="mt-5 w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
            >
              Comenzar
            </button>
          </div>
        </div>
      </div>
      <div
        class="col-span-5 md:col-span-3 bg-gradient-to-br from-gray-100 to-gray-400 h-96 md:h-auto"
      >
        <div
          class="absolute scroll-bg"
          style="
            height: 800%;
            width: 400%;
            background-size: 500px auto;
            background-image: url('./Desktop.png');
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// import Logo from "@/components/Logo";
export default {
  components: {
    //Logo,
  },
  methods: {
    navigate() {
      this.$router.push("/builder");
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-bg {
  -webkit-animation-name: scrollSmall;
  animation-name: scrollSmall;
  -webkit-animation-duration: 30s;
  animation-duration: 30s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
@keyframes scrollSmall {
  0% {
    transform: rotate(0) translateY(0);
  }
  100% {
    transform: rotate(0) translateY(-1278px);
  }
}
</style>